import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SetLinkedSoftAccountsPage from './SetLinkedSoftAccountsPage';
import {
    moveBack as moveBackAction,
    clearAuthNotification as clearAuthNotificationAction,
} from '../../actions/auth';
import { sendResetPasswordEmail as sendResetPasswordEmailAction } from '../../actions/email';

const _mapStateToProps = ({ authentication, social }) => ({
    email: authentication.email,
    socialData: social.socialData,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    moveBack: moveBackAction,
    onLinkedAccountsCreatePassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetLinkedSoftAccountsPage),
);
